import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../redux/api';

const PAGES = { terms: 'Terms and Conditions', privacy: 'Privacy Policy', service: 'Service Agreement / Service Usage' };

export default function LegalDocuments() {
  const [slug, setSlug] = useState('terms');
  const [document, setDocument] = useState(null);
  const [busy, setBusy] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [message, setMessage] = useState('');
  const [reload, setReload] = useState(0);
  useEffect(() => {
    let active = true;
    setDocument(null); setBusy(true); setMessage('');
    axiosInstance.get(`cms/legal/${slug}`).then(({ data }) => {
      if (!active) return;
      if (!data.status) throw new Error(data.message || 'Unable to load document');
      setDocument(data.response); setDirty(false);
    }).catch(error => { if (active) setMessage(error.message); })
      .finally(() => { if (active) setBusy(false); });
    return () => { active = false; };
  }, [slug, reload]);
  useEffect(() => {
    const warn = event => { if (dirty) { event.preventDefault(); event.returnValue = ''; } };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
  const canDiscard = () => !dirty || window.confirm('Discard unsaved changes?');
  const edit = (index, language, value) => {
    setDocument(current => ({ ...current, fields: current.fields.map((field, i) => i === index ? { ...field, [language]: value } : field) }));
    setDirty(true); setMessage('');
  };
  const save = async event => {
    event.preventDefault(); setBusy(true); setMessage('');
    try {
      const { data } = await axiosInstance.post(`cms/legal/${slug}`, document);
      if (!data.status) throw new Error(data.message || 'Unable to save document');
      setDocument(data.response); setDirty(false); setMessage('Saved. The public page now uses these changes.');
    } catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  };
  return <div className="p-3 category-wrapper">
    <h3>Legal Pages</h3>
    <p>Edit the existing English and Arabic text. Save publishes it on the corresponding website page.</p>
    <label htmlFor="legal-page">Page</label>
    <select id="legal-page" className="form-control mb-3" value={slug} disabled={busy}
      onChange={event => { if (canDiscard()) setSlug(event.target.value); }}>
      {Object.entries(PAGES).map(([key, title]) => <option value={key} key={key}>{title}</option>)}
    </select>
    {message && <p role="status">{message}</p>}
    {busy && !document && <p role="status">Loading…</p>}
    <button type="button" className="btn btn-outline-secondary mb-3" disabled={busy}
      onClick={() => { if (canDiscard()) setReload(value => value + 1); }}>Reload</button>
    {document && <form onSubmit={save}>
      <fieldset disabled={busy}>
        {document.fields.map((field, index) => <div key={field.key} className="row mb-4">
          {['en', 'ar'].map(language => <div className="col-md-6" key={language}>
            <label htmlFor={`legal-${index}-${language}`}>{language === 'en' ? 'English' : 'Arabic'} · Section {index + 1}</label>
            <textarea id={`legal-${index}-${language}`} className="form-control" rows={field[language].length > 150 ? 5 : 2}
              dir={language === 'ar' ? 'rtl' : 'ltr'} maxLength={20000} value={field[language]}
              onChange={event => edit(index, language, event.target.value)} />
          </div>)}
        </div>)}
        <button className="btn btn-primary" type="submit" disabled={!dirty}>{busy ? 'Saving…' : 'Save changes'}</button>
      </fieldset>
    </form>}
  </div>;
}
